import React from 'react';

// Chrome / Edge ignore autoComplete="off" on boxes that look like a name or a
// phone ("Surname", "Name", "Mobile") and pop up their own saved addresses over
// our phone-book list. An unknown autocomplete token plus a name that means
// nothing to them switches that off; data-lpignore / data-form-type keep
// password managers out too. Spread onto every phone-book box.
// key must not contain "name"/"tel"/"phone" - the browsers read the name too.
export const noBrowserAutofill = (key) => ({
  autoComplete: 'nope',
  name: `mf-${String(key).replace(/name|tel|phone|mobile/gi, 'x')}`,
  'data-lpignore': 'true',
  'data-form-type': 'other',
});

// The drop-down of matching phone contacts under one guest field (desktop).
// Logic: useContactSuggest (vm.contactSuggest). Items are picked on mouse-down
// so the field's blur does not close the list first.
export function ContactSuggestList({ cs, target, field }) {
  if (!cs.isOpen(target, field)) return null;
  return (
    <div className="cs-list" role="listbox">
      {cs.loading && !cs.results.length && <div className="cs-empty">Searching your contacts…</div>}
      {cs.results.map((p, i) => (
        <div key={p.key} role="option" aria-selected={i === cs.hi} className={'cs-item' + (i === cs.hi ? ' on' : '')}
          onMouseEnter={() => cs.setHi(i)} onMouseDown={(e) => { e.preventDefault(); cs.pick(p); }}>
          {/* The name as saved in the phone — what you recognise; the split into
              surname / name / father is a best guess you can still correct. */}
          <span className="cs-name" title={`Fills: ${[p.Surname, p.GuestName, p.FatherHusband].filter(Boolean).join(' · ')}`}>
            {p.display || [p.Surname, p.GuestName, p.FatherHusband].filter(Boolean).join(' ')}
          </span>
          <span className="cs-num">{p.MobileNumber || '—'}</span>
          <span className={'cs-label' + (p.primary ? ' cs-primary' : '')} title={p.primary ? 'The default number in the phone book' : undefined}>
            {p.primary ? '★ default' : `📇 ${p.label || 'contact'}`}
          </span>
        </div>
      ))}
    </div>
  );
}

// A labelled text box with the contact suggestions (used for the guest form's
// Surname / Name / Father-Husband / Mobile on desktop).
// context = the other names already typed for this guest (narrows the search).
export function ContactField({ cs, target, field, label, required, value, placeholder, onChange, inputMode, context }) {
  return (
    <label className="field cs-wrap">
      {label}{required && ' *'}
      <input value={value ?? ''} placeholder={placeholder} inputMode={inputMode} {...noBrowserAutofill(`${target}-${field}`)}
        onChange={(e) => { onChange(e.target.value); cs.typed(target, field, e.target.value, context); }}
        onKeyDown={(e) => cs.keyDown(e)}
        onBlur={() => cs.close()} />
      <ContactSuggestList cs={cs} target={target} field={field} />
    </label>
  );
}
